import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=357163da&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=357163da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357163da",
  null
  
)

export default component.exports